var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronDownRound = function SvgChevronDownRound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Chevron Down Round",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icons-\\uD83D\\uDD04",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-429.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevron---Down",
    transform: "translate(429.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.875,8.9999928 L11.995,12.8799928 L8.115,8.9999928 C7.92816847,8.81274013 7.67451764,8.7075072 7.41,8.7075072 C7.14548236,8.7075072 6.89183153,8.81274013 6.705,8.9999928 C6.315,9.3899928 6.315,10.0199928 6.705,10.4099928 L11.295,14.9999928 C11.685,15.3899928 12.315,15.3899928 12.705,14.9999928 L17.295,10.4099928 C17.685,10.0199928 17.685,9.3899928 17.295,8.9999928 C16.905,8.6199928 16.265,8.6099928 15.875,8.9999928 L15.875,8.9999928 Z",
    id: "icon/navigation/expand_more_24px"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDownRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chevron-down-round.7cb6cb063dab8d90acdea657865c500d.svg";